import React, {Component} from 'react';
import moment from 'moment';

import {getBlockColor} from '../utils/color';


const getWeek = (date) =>{
  const md = moment(date, 'M/D/YYYY');
  let wId = md.week();
  if (wId === 1 && md.month() === 11) {
    wId = md.add(-7, 'days').week() + 1;
  }
  return wId;
}

const getPoints = (rectW, h, margin, year, month, sd, sw) => {
  const startDay =  sd != null ? sd : moment([year, month]).day();
  const startWeek = sw || moment([year, month]).week() - 1;

  const x = startWeek * rectW;
  const y = startDay * rectW;

  const sY = h + margin.bottom;
  const diff = startDay > 0 ? rectW : 0;
  const eY = -margin.top;

  return {x, y, sY, diff, eY, startDay, startWeek};
}

const getAreaPath = (rectW, h, margin, year, month) => {
  const sp = getPoints(rectW, h, margin, year, month);
  let np;
  if (+month < 11) {
    np = getPoints(rectW, h, margin, year, +month + 1);
  } else {
    // December has 31 days, 31 % 7 = 3
    const nysd = (sp.startDay + 3) % 7;
    // if the new year's first day is Sunday or Monday, diff should be rectW
    const nyw = sp.startWeek + (sp.startDay >= 4 ? 5 : 4);
    np = getPoints(rectW, h, margin, year, null, nysd, nyw);
  }
  return `M ${sp.x}, ${h} V ${sp.y} h ${sp.diff} V 0 H ${np.x} h ${np.diff} V ${np.y} h ${-np.diff} V ${h} Z`;
}



class Block extends Component {
  constructor(props) {
    super(props);
    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
  }
  onMouseOver(e) {
    e.preventDefault()
    this.props.rectHovered(true, this.props.x, this.props.y, this.props.id, this.props.value, this.props.altValue);
  }
  onMouseOut(e) {
    e.preventDefault()
    this.props.rectHovered(false);
  }
}

// day, month, year block
class Rect extends Block {
  render() {
    const {x, y, width, height, fill} = this.props;
    const svgProp = {x, y, width, height, fill};
    return <rect
      className="block-day"
      {...svgProp}
      onMouseOver={this.onMouseOver}
      onTouchStart={this.onMouseOver}
      onMouseOut={this.onMouseOut}
      onTouchEnd={this.onMouseOut}
    />;
  }
}

class Line extends Block {
  render() {
    const {x, y, y2, stroke, strokeWidth} = this.props;
    const svgProp = {x1: x, x2: x, y1: y, y2, stroke, strokeWidth}
    return <line
      className="block-week"
      {...svgProp}
      onMouseOver={this.onMouseOver}
      onTouchStart={this.onMouseOver}
      onMouseOut={this.onMouseOut}
      onTouchEnd={this.onMouseOut}
    />;
  }
}

class Path extends Block {
  render() {
    return <path
      className="block-month"
      d={this.props.d}
      fill={this.props.fill}
      onMouseOver={this.onMouseOver}
      onTouchStart={this.onMouseOver}
      onMouseOut={this.onMouseOut}
      onTouchEnd={this.onMouseOut}
    />;
  }
}

class Blocks extends Component {

  render() {
    const {rectW, data, rectHovered, calendar, year, h, margin, unit, color} = this.props;

    const {steps} = calendar.range[unit];
    const dataByUnit = ['week', 'month'].map(unit => Object.entries(calendar.byUnit[unit]).map(d => [+d[0], d[1]]));

    const svgByUnit = {
      day: data.map(item =>
        <Rect
          key={"_id"+item.date}
          id={item.date}
          value={item.value}
          altValue={item.altValue}
          rectHovered={rectHovered}
          x={(getWeek(item.date) - 1) * rectW}
          y={moment(item.date, 'M/D/YYYY').day() * rectW}
          width={rectW}
          height={rectW}
          fill={getBlockColor(color, steps, item.value)}
        />),
      week: dataByUnit[0].map(item =>
        <Line
          key={"_id"+item[0]}
          id={item[0]}
          value={item[1]}
          rectHovered={rectHovered}
          x={item[0] * rectW + rectW / 2}
          y={item[0] === 0 ? moment(year, 'YYYY').day() * rectW : 0}
          y2={rectW * (item[0] === calendar.total.week ? moment(year + 1, 'YYYY').add(-1, 'days').day() + 1 : 7)}
          stroke={getBlockColor(color, steps, item[1])}
          strokeWidth={rectW}
        />),
      month: dataByUnit[1].map((item, i) => {
        const path = getAreaPath(rectW, h, margin, year, item[0]);
        const points = getPoints(rectW, h, margin, year, item[0]);
        return  (<Path
          key={"_id"+item[0]}
          id={item[0]}
          value={item[1]}
          rectHovered={rectHovered}
          x={points.x + points.diff}
          y={0}
          d={path}
          fill={getBlockColor(color, steps, item[1])}
        />);
      }),
    };

    return (<g transform={`translate(${margin.left}, ${margin.legend + margin.top})`}>{svgByUnit[unit]}</g>);
  }
}

export default Blocks;